module.exports = __webpack_public_path__ + "static/media/faculty.a330d0d8.svg";